import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { ReactSortable } from "react-sortablejs";
import Category from "./Category";
import { Modal, Button } from 'react-bootstrap';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrashAlt } from "@fortawesome/free-solid-svg-icons";
import DeleteDepartment from '../DeleteDepartment';

const Department = (props) => {

    const [showChildren, setShowChildren] = useState(0);
    // const [categories, setCategories] = useState(Object.values(props.item.categories));

    const toggleShow = () => {
        setShowChildren(showChildren ? false : true);
    }

    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);

    const handleShow = function (event) {
        event.preventDefault();
        setShow(true);
    };

    return (
        <div>
            <div className="department-outer">
                <div key={props.item.key} className="drag-item-parent" onClick={toggleShow}>{props.item.name}
                    {!props.item.categories || props.item.categories.length === 0 ?
                        <a onClick={handleShow} href="#" className="delete-dept">
                            <FontAwesomeIcon icon={faTrashAlt} />
                        </a>
                        : ''}
                </div>
                {showChildren && props.item.categories && props.item.categories.length !== 0 ?
                    <div className="child-div">
                        <Category categories={props.item.categories} slug={props.item.slug} setCategories={props.setCategories} department={props.item.slug} hideParent={props.hideParent} />
                    </div>
                    : ''}
            </div>
            <DeleteDepartment show={show} onHide={handleClose} item={props.item} />
        </div>

    );
}

export default Department;
